const search = (array, name, value) => {
  let match = false
  try {
    array.forEach((element, i) => {
      if (element[name] === value) {
        match = { ...element, index: i }
      }
    })
  } catch (error) {
    console.error(
      `Hubo un error al buscar "${name}" con valor "${value}" en el array "${
        Object.keys({ array })[0]
      }"`
    )
  }
  return match
}
export default search
